module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"createLinkTreeTitle":"Creating link tree","editLinkTreeTitle":"Editing link tree","name":"Name","emptyFieldError":"Required field","menus":"Menus"},"es":{"createLinkTreeTitle":"Creando un arbol de links","editLinkTreeTitle":"Editanto un arbol de links","name":"Nombre","emptyFieldError":"Campo obligatorio","menus":"Menus"}}')
  delete Component.options._Ctor
}
